/**
 * @title showPrintDialog
 * @description 打开浏览器打印框
 */
export const showPrintDialog = () => window.print()